import type { CountrySchema } from '@tectonics/prs/country';
import type { OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import type { UserInputValues } from '@tectonics/prs/user-input-values';
import { toInternationalPhoneNumber } from '@tectonics/utils/formatting';

export const buildCountryOutgoingPaymentMapper = ({ country, fields }: CountrySchema) => (
  (userInputValues: UserInputValues): Partial<OutgoingPayment> => ({
    country,
    ...Object.fromEntries(
      fields.map(({ id, validation }) => {
        const value = userInputValues[id];
        const mappedValue = validation === 'phone_number' && typeof value === 'string'
          ? toInternationalPhoneNumber(country, value)
          : value ?? '';

        return [id, mappedValue];
      }),
    ),
  })
);
